import CheckBox from '../../CheckBox';
export interface ICheckBoxProps {
	onValueChange: (checked: boolean) => void;
}
export default class OvverideCheckBox extends CheckBox {
	readonly props: ICheckBoxProps;
	constructor(props?: ICheckBoxProps) {
		super();
		this.props = props;
	}
	triggerValueChanged(checked: boolean) {
		if (this.props.onValueChange) {
			this.props.onValueChange(checked);
		}
	}
}
